import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-render-web-view',
  templateUrl: './render-web-view.component.html',
  styleUrls: ['./render-web-view.component.scss']
})
export class RenderWebViewComponent implements OnInit {
  private targatePage: string = '';

  constructor(private activatedRoute:ActivatedRoute, private router: Router) {
     this.targatePage = this.activatedRoute.snapshot.paramMap.get('targatePage');
  }

  ngOnInit(): void {
    if (window.localStorage.getItem("access_token")) {
        localStorage.setItem('token', window.localStorage.getItem("access_token"));
        this.redirect();
      }
    }

  redirect(){
    let routingUrl = '';
    switch(this.targatePage.toLowerCase()){
      case 'onboarding':{
        routingUrl = '/onboarding';
        break;
      }
    }
    return this.router.navigate([routingUrl]);
  }
}
